/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * List of categories
 */
export interface DrivingLicenseCategoryParam { 
    /**
     * Code of the driving license category.
     */
    categoryCode?: string;
    /**
     * Date of the initial expedition for the category.
     */
    initialExpeditionDate?: string;
    /**
     * Date not after this category is valid.
     */
    notAfterDate?: string;
    /**
     * Description of the restrictions affecting this category.
     */
    restrictions?: string;
}

